function initTestimonialSwipers() {
  if (!window.Swiper) return;

  document.querySelectorAll('.testimonial-swiper:not([data-swiper-ready])').forEach((el) => {
    el.setAttribute('data-swiper-ready', 'true');

    const delay = parseFloat(el.dataset.autoplayDelay) || 3500;
    const autoplayEnabled = el.dataset.autoplay !== 'false';
    const pagination = el.querySelector('.swiper-pagination');
    const prevEl = el.querySelector('.testimonial-swiper-arrow--prev');
    const nextEl = el.querySelector('.testimonial-swiper-arrow--next');

    new window.Swiper(el, {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 400,
      autoplay: autoplayEnabled
        ? {
            delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
          }
        : false,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl,
            }
          : false,
    });
  });
}

if (window.Swiper) {
  initTestimonialSwipers();
} else {
  // The Swiper CDN <script> tag loads synchronously right before this file, so this
  // is only a defensive fallback for the rare case that ordering assumption breaks.
  let attempts = 0;
  const retry = setInterval(() => {
    attempts += 1;
    if (window.Swiper || attempts > 20) {
      clearInterval(retry);
      initTestimonialSwipers();
    }
  }, 100);
}
